import React, { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { services } from '../data/services';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const fieldClass = 'mt-1.5 w-full border border-neutral-300 bg-white px-3 py-2.5 text-sm text-ink outline-none transition-colors placeholder:text-neutral-400 focus:border-ink focus:ring-2 focus:ring-gold/60';
const labelClass = 'block font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-500';
export function QuoteCard() {
  const [status, setStatus] = useState<Status>('idle');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState(services[0].name);
  const [message, setMessage] = useState('');
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!name.trim() || !phone.trim()) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <div className="w-full max-w-md border-t-4 border-gold bg-white p-7 sm:p-8 lg:w-[26rem]" data-id="element-138" data-mp="3hr9zp1e7ljf5">
      {status === 'success' ? <div role="status" className="py-6" data-id="element-139" data-mp="3rie4x9e31pws">
          <span className="inline-flex h-11 w-11 items-center justify-center bg-gold" data-id="element-140" data-mp="3rjpiu218se1m">
            <Check className="h-5 w-5 text-ink" aria-hidden="true" data-id="element-141" data-mp="3vjzo1ch7n0ff" />
          </span>
          <h2 className="mt-5 text-xl font-semibold tracking-tight text-ink" data-id="element-142" data-mp="2yva5djxre3se">
            Thanks, {name.split(' ')[0]}.
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-neutral-600" data-id="element-143" data-mp="33vfqsidfqu21">
            We'll call {phone} within one business day with your free estimate
            for {service.toLowerCase()}.
          </p>
        </div> : <form onSubmit={handleSubmit} noValidate data-id="element-144" data-mp="n4y2c68njinl">
          <h2 className="text-xl font-semibold tracking-tight text-ink" data-id="element-145" data-mp="n464spvhvauo">
            Request a free quote
          </h2>
          <p className="mt-2 text-sm text-neutral-600" data-id="element-146" data-mp="s5vhe9yd7wkv">
            Senior &amp; veteran discounts available.
          </p>

          <div className="mt-6 grid gap-4" data-id="element-147" data-mp="2k5lsextmjugx">
            <div data-id="element-148" data-mp="2k4sjbq770svm">
              <label htmlFor="q-name" className={labelClass} data-id="element-149" data-mp="2k7eq3nm9f4cs">
                Name
              </label>
              <input id="q-name" value={name} onChange={e => {
            setName(e.target.value);
            setStatus('idle');
          }} placeholder="Jane Doe" className={fieldClass} data-id="element-150" data-mp="2y30lccj36kdn" />
            </div>
            <div className="grid gap-4 sm:grid-cols-2" data-id="element-151" data-mp="2f68yxu88zp5d">
              <div data-id="element-152" data-mp="2f7tpz9vcspyh">
                <label htmlFor="q-phone" className={labelClass} data-id="element-153" data-mp="2f8bsupciu2fd">
                  Phone
                </label>
                <input id="q-phone" type="tel" value={phone} onChange={e => {
              setPhone(e.target.value);
              setStatus('idle');
            }} placeholder="(971) 000-0000" className={fieldClass} data-id="element-154" data-mp="1mpy7vqcaaaxp" />
              </div>
              <div data-id="element-155" data-mp="21m22va84wcd">
                <label htmlFor="q-email" className={labelClass} data-id="element-156" data-mp="3kdikcevhw4fu">
                  Email
                </label>
                <input id="q-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" className={fieldClass} data-id="element-157" data-mp="3oelxgtm5rmdd" />
              </div>
            </div>
            <div data-id="element-158" data-mp="6xkinwpb9a28">
              <label htmlFor="q-service" className={labelClass} data-id="element-159" data-mp="6y41rgqp64hu">
                Service
              </label>
              <select id="q-service" value={service} onChange={e => setService(e.target.value)} className={fieldClass} data-id="element-160" data-mp="bvvta9nfjoli">
                {services.map(s => <option key={s.name} value={s.name} data-id="element-161" data-mp="3bxb4xncxx4j6">
                    {s.name}
                  </option>)}
              </select>
            </div>
            <div data-id="element-162" data-mp="374rrcqe969ed">
              <label htmlFor="q-message" className={labelClass} data-id="element-163" data-mp="327rk4c5o30lo">
                Message <span className="normal-case tracking-normal" data-id="element-164" data-mp="325ov9vg93dij">(optional)</span>
              </label>
              <textarea id="q-message" rows={3} value={message} onChange={e => setMessage(e.target.value)} placeholder="Two-story house in Keizer, moss on the north side of the roof." className={`${fieldClass} resize-none`} data-id="element-165" data-mp="2y43azp1dzwyb" />
            </div>
          </div>

          {status === 'error' && <p role="alert" className="mt-4 text-sm font-medium text-red-600" data-id="element-166" data-mp="3gz0fz305xi79">
              Please add your name and a phone number so we can reach you.
            </p>}

          <button type="submit" disabled={status === 'submitting'} className="mt-6 inline-flex w-full items-center justify-center gap-2 bg-ink px-6 py-3.5 text-sm font-bold uppercase tracking-[0.08em] text-white transition-colors hover:bg-ink-soft disabled:opacity-70" data-id="element-167" data-mp="25g7fgnnk0b34">
            {status === 'submitting' && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-168" data-mp="yr4nwmq53gj4" />}
            {status === 'submitting' ? 'Sending' : 'Send request'}
          </button>
        </form>}
    </div>;
}